module.exports = __webpack_public_path__ + "img/tertiary_1x4.88ac592f.svg";